import { CoacheeBenefits } from "@/components/Coachee/CoacheeBenefits";
import { CoacheeFAQ } from "@/components/Coachee/CoacheeFAQ";
import { CoacheeHero } from "@/components/Coachee/CoacheeHero";
import { CoacheeTestimonials } from "@/components/Coachee/CoacheeTestimonials";
import { CoacheeContactForm } from "@/components/LandingPage/CoacheeContactForm";
import { Footer } from "@/components/LandingPage/Footer";

import { Box } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Head from "next/head";

export default function Coachee() {
  const t = useTranslations();
  return (
    <>
      <Head>
        <title>{t("CoacheePage.title")}</title>
      </Head>
      <Box>
        <CoacheeHero />
        <CoacheeBenefits />
        <CoacheeTestimonials />
        <CoacheeFAQ />
        <CoacheeContactForm />
        <Footer />
      </Box>
    </>
  );
}

export const getServerSideProps = () => {
  return { props: {} };
};
